import * as THREE from "three";
import { useRef, useEffect, useState } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import {
  MarchingCubes,
  MarchingCube,
  MeshTransmissionMaterial,
  Environment,
  Bounds,
} from "@react-three/drei";
import { Physics, RigidBody, BallCollider } from "@react-three/rapier";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { useControls } from "leva";

const API_URL =
  "https://yfjo09qnd7.execute-api.ap-northeast-1.amazonaws.com/prod/get-random-color";
const State = Object.freeze({
  default: 0,
  purpose: 1,
  vision: 2,
});

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
      return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
  }

  return "unknown";
}

let device = getMobileOperatingSystem();

let metaball_state = State.default;
let metaball_flag = false;
let color_list = [];

function MetaBall({ color, vec = new THREE.Vector3(), ...props }) {
  // let default_pos = vec;
  const api = useRef();
  const target = useRef();

  const activeEnterRef = useRef(false);
  const activeRef = useRef(false);

  // let v = 0;

  // const option = useControls({
  //   enterSpeed: { value: device === "iOS" ? 0.02 : device === "Android" ? 0.15 : 0.1, min: 0, max: 1 },

  //   exitSpeed: { value: device === "iOS" ? 0.05 : device === "Android" ? 0.05  : 0.2, min: 0, max: 1 },

  //   duration: { value: 1, min: 0, max: 10 },
  // });

  const option = {
    enterSpeed:  device === "iOS" ? 0.05 : device === "Android" ? 0.15 : 0.1,

    exitSpeed: device === "iOS" ? 0.05 : device === "Android" ? 0.05  : 0.2,

    duration : 5,

  };

  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    // purpose top 
    const metaSection = document.querySelector("#purpose_top");


    ScrollTrigger.create({
      trigger: metaSection,
      start: "-=500px 20%",
      end: "bottom+=300px 60%",
      scrub: true,
      // markers: true,
      // toggleActions: "play none none reverse",
      onEnter: () => {
        activeRef.current = false;
        activeEnterRef.current = true;
      },
      onLeave: () => {
        activeRef.current = true;
          activeEnterRef.current = false;
      },
      onEnterBack: () => {
        activeRef.current = false;
        activeEnterRef.current = true;
      },
      onLeaveBack: () => { 
        activeRef.current = true;
        activeEnterRef.current = false;
      }
    });


    // future vision 
    const future = document.querySelector("#future_vision-statement");


    ScrollTrigger.create({
      trigger: future,
      start: "top 20%",
      end: "bottom-=10% 60%",
      // duration: 2,
      scrub: true,
      // markers: true,
      // toggleActions: "play none none reverse",
      onEnter: () => {
        activeRef.current = false;
        activeEnterRef.current = true;
      },
      onLeave: () => {
        activeRef.current = true;
          activeEnterRef.current = false;
      },
      onEnterBack: () => {
        activeRef.current = false;
        activeEnterRef.current = true;
      },
      onLeaveBack: () => { 
        activeRef.current = true;
        activeEnterRef.current = false;
      }
      
    });


    // visual
    const visual = document.querySelector("#visual_message");
    ScrollTrigger.create({
      trigger: visual,
      start: "-=20% 20%",
      end: "bottom+=20% 60%",
      scrub: true,
      // markers: true,
      // toggleActions: "play none none reverse",
      onEnter: () => {
        activeRef.current = false;
        activeEnterRef.current = true;
      },
      onLeaveBack: () => { 
        activeRef.current = true;
        activeEnterRef.current = false;
      }
    });
  }, []);

  useFrame((state, delta) => {
    if (!activeEnterRef.current) return;
    delta = Math.min(delta, 0.03);
    if (api.current) {
      api.current.applyImpulse(
        vec
          .copy(api.current.translation())
          .normalize()
          .multiplyScalar(delta * -option.enterSpeed)
      );
    }
  });

  useFrame((state, delta) => {
    if (!activeRef.current) return; // Only run if activeRef is true

    // Clamp delta to prevent large jumps in slow frame rates
    delta = Math.min(delta, 0.03);

    // Set the target position for the animation
    vec.set(props.position[0], props.position[1], props.position[2]);

    if (api.current) {
      api.current.applyImpulse(
        vec
          .copy(api.current.translation())
          .normalize()
          .multiplyScalar(delta * option.exitSpeed)
      );
    }
  });

  return (
    <RigidBody
      // type="kinematicPosition"
      ref={api}
      colliders={false}
      linearDamping={window.innerWidth > 768 ? 1 : 0.7}
      angularDamping={window.innerWidth > 768 ? 1.5 : 1}
      {...props}
    >
      <MarchingCube
        strength={window.innerWidth > 768 ? 0.4 : 0.2}
        subtract={10}
        color={color}
      />
      <mesh>
        <sphereGeometry args={[0.0]} />
      </mesh>
      <BallCollider
        ref={target}
        args={[window.innerWidth > 768 ? 0.1 : 0.09]}
        type="dynamic"
      />
    </RigidBody>
  );
}

let on = false;
// let visual_on = false;
function MetaballGenerator({ ...props }) {
  const [num, setNum] = useState(0);

    

  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    // purpose top
    const purpose = document.querySelector("#purpose_top");


    ScrollTrigger.create({
      trigger: purpose,
      start: "-=20% 20%",
      end: "bottom+=20% 60%",
      // duration: 2,
      // scrub: true,
      // markers: true,
      onEnter: () => {
        requestAnimationFrame(() => {
        on = true;
        metaball_state = State.purpose;
        metaball_flag = true;
        setNum(metaball_state);
        });
      },
      onLeave: () => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            metaball_state = State.default;
            metaball_flag = false;
            setNum(metaball_state);
            on = false;
          }, 1000);

        });
        
      },
      onEnterBack: () => {
        requestAnimationFrame(() => {
        on = true;
        metaball_state = State.purpose;
        metaball_flag = true;
        setNum(metaball_state);
        });
      },
      onLeaveBack: () => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            metaball_state = State.default;
            metaball_flag = false;
            setNum(metaball_state);
            on = false;
          }, 1000);

        });
      },
    });

    // future vision
    const futureContainer = document.querySelector("#future_vision-statement");
    


    ScrollTrigger.create({
      trigger: futureContainer,
      start: "top 20%",
      end: "bottom+=30% 60%",
      // duration: 2,
      // scrub: true,
      // markers: true,
      // toggleActions: "play none none reverse",
      onEnter: () => {
        requestAnimationFrame(() => {
        on = true;
        metaball_state = State.vision;
        metaball_flag = true;
        setNum(metaball_state);
        console.log(metaball_state);
        
        });
      },
      onLeave: () => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            metaball_state = State.default;
            metaball_flag = false;
            setNum(metaball_state);
            on = false;
            console.log(metaball_state);
          }, 1000);

        });
        
      },
      onEnterBack: () => {
        requestAnimationFrame(() => {
        on = true;
        metaball_state = State.vision;
        metaball_flag = true;
        setNum(metaball_state);
        console.log(metaball_state);
        });
      },
      onLeaveBack: () => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            metaball_state = State.default;
            metaball_flag = false;
            setNum(metaball_state);
            on = false;
            console.log(metaball_state);
          }, 1000);

        });
      },
    });

    // visual
    const visual = document.querySelector("#visual_message");


    ScrollTrigger.create({
      trigger: visual,
      start: "-=20% 20%",
      end: "bottom+=20% 60%",
      // duration: 2,
      // scrub: true,
      // markers: true,
      // toggleActions: "play none none reverse",
      onEnter: () => {
        requestAnimationFrame(() => {
        on = true;
        metaball_state = State.purpose;
        metaball_flag = true;
        setNum(metaball_state);
        });
      },
      onLeaveBack: () => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            metaball_state = State.default;
            metaball_flag = false;
            setNum(metaball_state);
            on = false;
          }, 1000);

        });
      },
    });

  }, []);

  const target = useRef(null);

  // State毎にメタボールを出し分け
  let metaballContent = null;

  switch (metaball_state) {
    case State.purpose:
      metaballContent = (
        <group ref={target}>
          <MetaBall color={color_list[0]} position={[3, 3, 0.5]} />
          <MetaBall color={color_list[1]} position={[2, 2, 0.5]} />
          <MetaBall color={color_list[2]} position={[1, 1, 0.5]} />

          <MetaBall color={color_list[3]} position={[-1, -1, -0.5]} />
          <MetaBall color={color_list[4]} position={[2, 2, 0.5]} />
          <MetaBall color={color_list[5]} position={[-2, -2, -0.5]} />
          <MetaBall color={color_list[6]} position={[-1, -3, -0.5]} />
          <MetaBall color={color_list[7]} position={[-1, -3, -0.5]} />
          <Mover />
        </group>
      );
      break;

    case State.vision:
      metaballContent = (
        <>
          <MetaBall color={"#ff1668"} position={[0.5, 0.5, 0.5]} />
          <MetaBall color={"#0586ff"} position={[-0.5, -0.5, -0.5]} />

          <MetaBall color={color_list[9]} position={[3, 3, 0.5]} />
          <MetaBall color={color_list[10]} position={[3, 2, 0.5]} />
          <MetaBall color={color_list[11]} position={[-3, -4, 0.5]} />

          <MetaBall color={color_list[12]} position={[-2, -4, -0.5]} />
          <MetaBall color={color_list[13]} position={[4, 2, 0.5]} />
          <MetaBall color={color_list[14]} position={[-2, -3, -0.5]} />
          <MetaBall color={color_list[15]} position={[-1, -3, -0.5]} />
          <MetaBall color={color_list[16]} position={[-1, -3, -0.5]} />
          <Mover />
        </>
      );
      break;

    default:
      break;
  }

  return (
    <MarchingCubes
      resolution={90}
      maxPolyCount={20000}
      enableUvs={false}
      enableColors
    >
      <MeshTransmissionMaterial
        vertexColors
        transmissionSampler
        transmission={0.55}
        thickness={0.3}
        roughness={0}
        chromaticAberration={2.8}
        anisotropy={0.5}
        envMapIntensity={1.8}
        distortion={1.5}
        distortionScale={1.6}
        temporalDistortion={0.1}
        iridescence={1.5}
        iridescenceIOR={1.6}
        iridescenceThicknessRange={[0, 1400]}
        toneMapped={false}
      />
      {metaballContent}
      <Pointer />
    </MarchingCubes>
  );
}

// マウスカーソル位置に追従するメタボールを表示
function Pointer({ vec = new THREE.Vector3() }) {
  const r = useRef();
  useFrame(({ pointer, viewport }) => {
    const { width, height } = viewport.getCurrentViewport();
    vec.set(pointer.x * (width / 2), pointer.y * (height / 2), 0);
    try {
      r.current.setNextKinematicTranslation(vec);
    } catch {}
  });
  return (
    <RigidBody type="kinematicPosition" colliders={false} ref={r}>
      {window.innerWidth > 768 ? (
        <MarchingCube strength={0.1} subtract={5} color="white" />
      ) : null}
      <mesh>
        <meshPhongMaterial color="#ffffff" opacity={0.1} transparent />
        <sphereGeometry args={[0.0]} />
      </mesh>
      <BallCollider args={[0.1]} type="dynamic" />
    </RigidBody>
  );
}

// メタボールをかき混ぜる透明なメタボール
let v = 0;
function Mover({ vec = new THREE.Vector3() }) {
  const ref = useRef();
  useFrame((state, delta) => {
    v += delta * 6;
    if (v > 1000) v = 0;

    vec.set(
      window.innerWidth > 768 ? Math.cos(v) / 2 : Math.cos(v) / 15,
      window.innerWidth > 768 ? Math.sin(v) / 7 : Math.sin(v) / 25,
      window.innerWidth > 768 ? Math.sin(v) / 8 : Math.sin(v)/ 25
    );

    if (ref.current) {
      ref.current.setNextKinematicTranslation(vec);
      ref.current.applyImpulse(
        vec
          .copy(ref.current.translation())
          .normalize()
          .multiplyScalar(delta * -0.8)
      );
    }
  });

  return (
    <RigidBody ref={ref} type="kinematicPosition" colliders={false}>
      <MarchingCube strength={0} subtract={0} color={"#b50039"} />
      <BallCollider
        args={[window.innerWidth > 768 ? 0.1 : 0.01]}
        type="dynamic"
      />
    </RigidBody>
  );
}

export function App() {
  // apiからメタボールのカラーリストをフェッチ
  useEffect(() => {
    if (color_list.length === 0) {
      fetch(API_URL)
        .then((res) => res.json())
        .then((json) => {
          color_list = json["body"];
        })
        .catch(() => {
          console.error("APIからデータを読み込めません。");
        });
    }
  }, []);

  const [boundsMargin, setBoundsMargin] = useState(1);

  function handleResize() {
    if (window.innerWidth > 768) {
      setBoundsMargin(1);
    } else {
      setBoundsMargin(0.5);
    }
  }

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  return (
    <Canvas
      resize={{ debounce: 0 }}
      dpr={[2, 1.5]}
      camera={{
        position: [0, 0, window.innerWidth > 768 ? 4 : 7], // Pull back slightly on mobile
        fov: window.innerWidth > 768 ? 15 : 15, // Wider FOV on mobile
      }}
      style={{ width: "100vw", height: "100vh" }}
    >
      <Physics gravity={[0, 0, 0]}>
        <MetaballGenerator />
      </Physics>

      <Environment files="https://d2iujyafz27ty7.cloudfront.net/VisionProject/assets/A.hdr" />

      <Bounds fit observe margin={boundsMargin}>
        <mesh visible={false}>
          <boxGeometry />
        </mesh>
      </Bounds>
    </Canvas>
  );
}
